import React, {useEffect, useState,} from 'react';
import PropTypes from 'prop-types';
import I18n from "i18n-js";
import InputMask from "react-input-mask";

const DatePicker = ({handleDateChange, formID, isRequired}) => {
    const [date,setDate] = useState();
    useEffect(()=>{
        $(`#${formID}`).datepicker({
            dateFormat: "yy-mm-dd",
                changeMonth: true,
                changeYear: true,
                yearRange: "1930:"+ new Date().getFullYear(),
                defaultDate: "-15y"
        });
        $(`#${formID}`).datepicker().val();
        $(`#${formID}`).datepicker().on('change',()=>{
            setDate($(`#${formID}`).datepicker().val());
            handleDateChange($(`#${formID}`).datepicker().val(),formID);
        });
        return () =>{
            $(`#${formID}`).datepicker('destroy')
        }
    },[])

    return(
        <InputMask className={isRequired ? "string date required" : "string date"} value={date} type="text" required={isRequired ? "required" : ""} id={formID} name='date' placeholder={I18n.t("date_placeholder")} mask={"9999-99-99"} />
    )
}

DatePicker.PropTypes={
    handleDateChange: PropTypes.func.isRequired,
    formID: PropTypes.string.isRequired
}

export default DatePicker;